import React, { useState } from 'react';
import MinimalLayout from '@/Layouts/MinimalLayout';
import ThreadList from './ThreadList';
import MessageWindow from './MessageWindow';
import { Head } from '@inertiajs/react';

export default function MessengerPage({ threads }) {
    const [activeThreadId, setActiveThreadId] = useState(null);

    const handleThreadSelect = (threadId) => {
        setActiveThreadId(threadId);
    };

    return (
        <>
            <Head title="Messages" />

            <div className="container-fluid" style={{ 
                height: 'calc(100vh - 120px)', // Adjust based on your header + footer height
                overflow: 'hidden',
                padding: '20px 0'
            }}>
                <div className="row h-100" style={{ margin: 0 }}>
                    <div className="col-3 border-end h-100" style={{ 
                        overflowY: 'auto',
                        padding: '0 15px'
                    }}>
                        {threads.length > 0 ? (
                            <ThreadList
                                threads={threads}
                                onThreadSelect={handleThreadSelect}
                                activeThreadId={activeThreadId}
                            />
                        ) : (
                            <div className="p-4 text-center">
                                You have no messages yet. Visit a user's profile to start a conversation.
                            </div>
                        )}
                    </div>
                    <div className="col-9 h-100" style={{ 
                        display: 'flex',
                        flexDirection: 'column',
                        padding: 0,
                        overflow: 'hidden'
                    }}>
                        <MessageWindow threadId={activeThreadId} />
                    </div>
                </div>
            </div>
        </>
    );
}
